import { ICollectionCards } from './types';

export const mapCollectionCards = ({ prismicContent }): ICollectionCards => {
  const { desktop, mobile, title, carousel } = prismicContent.primary;

  const collectionCards = {
    desktop,
    mobile,
    title,
    carousel,
    collections: prismicContent.items.map(
      ({ collection, img, title, bgcolor }) => {
        return { ...collection, img, customTitle: title, bgColor: bgcolor };
      },
    ),
  };

  return collectionCards;
};
